import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import Inicio from "./Components/Inicio.js";
import Shop_tiendas from "./Components/Shop_tiendas.js";
import About from "./Components/About.js";
import Grid_razas from "./Components/Grid_razas.js";
import Checkout_ok from "./Components/Checkout_ok.js";
import Checkout_fail from "./Components/Checkout_fail.js";

import "./App.css";

function App() {
  useEffect(() => {
    localStorage.setItem("levanta_pago", 0);
  }, []);

  return (
    <Router className="App">
      <div className="header">
        <div className="top_titulo">
          <Link to="/">
            <img
              className="img_header"
              src="/img/logo_white_header2.png"
              alt=""
            ></img>
          </Link>
        </div>

        <div className="menu">
          <Link
            className="menu_link"
            to="/"
            onClick={() => window.open("https://ventu.cl/cornerdog", "_blank")}
          >
            <img src="/img/m_1.png" alt=""></img>
          </Link>
          {/* <Link className="menu_link" to="/razas">
            <img src="/img/m_2.png" alt=""></img>
          </Link> */}
          <a href="https://api.whatsapp.com/send/?phone=56966564743&text&app_absent=0">
            <img src="/img/m_4.png" alt=""></img>
          </a>
          <a href="https://www.instagram.com/corner__dog/?hl=es">
            <img src="/img/m_6.png" alt=""></img>
          </a>
        </div>
      </div>

      <Switch>
        <Route path="/" exact component={Inicio} />
        <Route path="/tiendas" exact component={Shop_tiendas} />
        <Route path="/razas" exact component={Grid_razas} />
        <Route path="/about" exact component={About} />
        <Route path="/checkout" exact component={Checkout_ok} />
        <Route path="/error" exact component={Checkout_fail} />
      </Switch>
    </Router>
  );
}

export default App;
